import { GridComponentTypes } from "./static-grid.types";

import "./static-grid.styles.scss";

const StaticGrid = ({ children, columns }: GridComponentTypes) => {
  return <div className={`grid grid-${columns}`}>{children}</div>;
};

export default StaticGrid;
